enum PackageTypeEnum {
	SURVEY = 0,
	STATISTICAL = 1,
	EVENT = 2,
	SPECIAL = 3,
}

export const PACKAGE_TYPE_ENUM_TK_MAP: Record<PackageTypeEnum, string> = {
	[PackageTypeEnum.SURVEY]: "i18n.enums.packageType.SURVEY",
	[PackageTypeEnum.STATISTICAL]: "i18n.enums.packageType.STATISTICAL",
	[PackageTypeEnum.EVENT]: "i18n.enums.packageType.EVENT",
	[PackageTypeEnum.SPECIAL]: "i18n.enums.packageType.SPECIAL",
};

export default PackageTypeEnum;
